import { render, staticRenderFns } from "./ArtistSearchCustom.vue?vue&type=template&id=73bbde63&scoped=true"
import script from "./ArtistSearchCustom.vue?vue&type=script&lang=js"
export * from "./ArtistSearchCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bbde63",
  null
  
)

export default component.exports